var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HSuccess'),_c('h2',{staticClass:"text-center mw-300 mx-auto mb-10 green--text"},[_vm._v(" "+_vm._s(_vm.$t('quote.hint.paymentSuccess'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }